import React from 'react'
import './Contact.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPhone, faEnvelope, faLocationDot} from '@fortawesome/free-solid-svg-icons';
const Contact = () => {

    function handleFormSubmit(){
        const errorName = document.getElementById('err-name');
        const errorEmail = document.getElementById('err-email');
        const errorMsg = document.getElementById('err-message');
        const name = document.getElementById('name');
        const email = document.getElementById('email');
        const message = document.getElementById('message');
        if(name.value == '' || name.value == null){
            name.focus();
            errorName.textContent = 'Please Write Your Name'
            return
        }else{
            errorName.textContent = ''
        }
        if(email.value == '' || email.value == null){
            email.focus();
            errorEmail.textContent = 'Please Write Your Email'
            return
        }else{
            errorEmail.textContent = ''
        }
        if(message.value == '' || message.value == null){
            message.focus();
            errorMsg.textContent = 'Please Write Your Message'
            return
        }else{
            errorMsg.textContent = ''
        }
    }

    function validateName(e){
        e.preventDefault();
        const name = document.getElementById('name');
        const fullNameregex= /^[a-zA-Z\s\.]+$/;
        if (fullNameregex.test(e.target.value) === false) {
            name.value = name.value.slice(0,name.value.length - 1)
          }
    }
    function validateEmail(e){
        e.preventDefault();
        const errorEmail = document.getElementById('err-email');
        const email = document.getElementById('email');
        if(email.value == '' || email.value == null){
            errorEmail.textContent = 'Please Write Your Email'
            return
        }else{
            errorEmail.textContent = ''
        }
        const emailregex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailregex.test(email.value) === false) {
            errorEmail.textContent = "Please enter a valid Email";
            email.value = "";
            return 
        }else{
            errorEmail.textContent = " ";
        }
    }

    return (
        <>
            <div className="sections" id='contactSection'>
                <div className="section-title"><span>04 .</span><h3>Contact Me</h3></div>
                <div className="contact-main-sec">
                    <div className="left-contact-sec">
                        <a href="tel:7406959839" className="contact-list">
                            <FontAwesomeIcon icon={faPhone} size="3x" className="c-list-icon" shake/> 
                            <div className="contact-details">
                                <p className="c-title">Call Me</p>
                                <p className="c-link">91+ 7406959839</p>
                            </div>
                        </a>
                        <a href="mailto:mohammedsaqibbca62@gmsil.com" className="contact-list">
                            <FontAwesomeIcon icon={faEnvelope} size="3x" className="c-list-icon" shake/> 
                            <div className="contact-details">
                                <p className="c-title">Email</p>
                                <p className="c-link">mohammedsaqibbca62<wbr/>@gmail.com</p>
                            </div>
                        </a>
                        <div className="contact-list">
                            <FontAwesomeIcon icon={faLocationDot} size="3x" className="c-list-icon" shake/> 
                            <div className="contact-details">
                                <p className="c-title">Location</p>
                                <p className="c-link">Bangalore, Wilson Garden</p>
                            </div>
                        </div>
                    </div>
                    <div className="right-contact-sec">
                        <form action="https://formsubmit.co/5a255bf1845ddf18a6e2f38a69f7a992" method="POST" className='contact-form'>
                            <div className="form-group">
                                <p className="error" id='err-name'></p>
                                <div className="form-group-input">
                                    <input className='focusAnim' type="text" name="name" id="name" required autoComplete='off' onInput={validateName}/>
                                    <span>Full Name</span>
                                </div>
                            </div>
                            <div className="form-group">
                                <p className="error" id='err-email'></p>
                                <div className="form-group-input">
                                    <input className='focusAnim' type="email" name="email" id="email" required autoComplete='off' onBlur={validateEmail}/>
                                    <span>Email</span>
                                </div>
                            </div>
                            <div className="form-group">
                                <p className="error" id='err-message'></p>
                                <div className="form-group-input">
                                    <textarea className='focusAnim' name="message" id="message" required autoComplete='off' />
                                    <span>Your Message</span>
                                </div>
                            </div>
                            <div className="form-group">
                                <button className='submitBtn' id='submit' onClick={handleFormSubmit}>Send</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contact;